import React from 'react';
import { useTranslation } from '../i18n/LanguageProvider';

const TrustBar: React.FC = () => {
  const { t } = useTranslation();
  return (
    <section className="bg-navy py-8">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col md:flex-row justify-center items-center space-y-4 md:space-y-0 md:space-x-12 text-sand">
          <div className="flex items-center space-x-2">
            <svg className="w-5 h-5 text-sky" fill="currentColor" viewBox="0 0 20 20">
              <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
            </svg>
            <span className="text-sm md:text-base">{t('trust.item1')}</span>
          </div>
          <div className="flex items-center space-x-2">
            <svg className="w-5 h-5 text-sky" fill="currentColor" viewBox="0 0 20 20">
              <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
            </svg>
            <span className="text-sm md:text-base">{t('trust.item2')}</span>
          </div>
          <div className="flex items-center space-x-2">
            <svg className="w-5 h-5 text-sky" fill="currentColor" viewBox="0 0 20 20">
              <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
            </svg>
            <span className="text-sm md:text-base">{t('trust.item3')}</span>
          </div>
        </div>
      </div>
    </section>
  );
};

export default TrustBar;
